'use server';

import { SessionService } from '@/contexts/authentication';
import { getTokenManager } from '@/contexts/subscriptions/services/getTokenManager';
import { walletAccountId } from '@/contexts/subscriptions/services/walletAccountId';

export async function getBalance(): Promise<{ balance: number } | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;

  // The wallet lives centrally (accounts). Read through the central wallet
  // (getTokenManager → PortalBillingAdapter → GET /billing/balance). READ-only:
  // no debit, money-safe.
  const balance = await getTokenManager().getBalance(await walletAccountId(familyId));
  return { balance };
}
